<template>
<!-- 为灵活信号设置页面提供修改信号的modal页面，根据信号的name展示不同的修改选项 -->
  <div>
    <Row>
      <Modal
        v-model="m_open_modal_switch"
        :title="this.get_modal_title()"
        :loading="loading_status"
        @on-ok="set_ok"
        @on-cancel="set_cancel"
        @on-visible-change="set_changed"
      >
        <p slot="header" class="demo-drawer-hearde">
          <Icon type="information-circled"></Icon>
          <span>{{ this.get_modal_title() }}</span>
        </p>
        <Row>
          <Col span="20" offset="2">
          <div v-if="this.m_type === 'sign' && this.name === 'ma'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="短MA参数">
                  <Slider
                    v-model="m_paras[0]"
                    :step="1"
                    :max="1500"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="长MA参数">
                  <Slider
                    v-model="m_paras[1]"
                    :step="1"
                    :max="1500"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="重采样参数">
                  <Select v-model="m_paras[2]" style="minwidth:200px">
                    <Option v-for="item in ma_interval[m_paras[3]]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="重采样频率">
                <Tooltip content="m=分钟, h=小时" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[3]" style="minwidth:200px" @on-change="m_or_h_change">
                    <Option v-for="item in [{value:'m',label:'m'}, {value:'h',label:'h'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[4]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'ema'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="短EMA参数">
                  <Slider
                    v-model="m_paras[0]"
                    :step="1"
                    :max="1500"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="长EMA参数">
                  <Slider
                    v-model="m_paras[1]"
                    :step="1"
                    :max="1500"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="重采样参数">
                  <Select v-model="m_paras[2]" style="minwidth:200px">
                    <Option v-for="item in ma_interval[m_paras[3]]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="重采样频率">
                <Tooltip content="m=分钟, h=小时" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[3]" style="minwidth:200px" @on-change="m_or_h_change">
                    <Option v-for="item in [{value:'m',label:'m'}, {value:'h',label:'h'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[4]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'price_judge'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="上穿/下穿">
                <Tooltip content="上穿(Up):标的价格>=设定价格即触发信号;下穿(Down):标的价格<=设定价格即触发信号" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[0]" style="minwidth:200px">
                    <Option v-for="item in [{value:'up',label:'Up'}, {value:'down',label:'Down'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="设定价格">
                  <InputNumber
                    v-model="m_paras[1]"
                    :min="0"
                    :active-change="false"
                  ></InputNumber>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[2]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'sign_price_drop_judge'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="拉升触发/回落触发">
                <Tooltip content="拉升触发(Up)用于超跌反弹场景;回落触发(Down)用于冲高回落场景" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[0]" style="minwidth:200px">
                    <Option v-for="item in [{value:'up',label:'Up'}, {value:'down',label:'Down'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="拉升/回落临界幅度">
                <Tooltip content="拉升触发场景(Up):价格下跌刷新记录新低后回升, 回升现价/记录最低价-1>=临界幅度，即触发信号;回落触发场景(Down):价格上涨刷新记录新高后回落, 取绝对值(回落现价/记录最高价-1)>=临界幅度，即触发信号" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                    v-model="m_paras[1]"
                    :max="1"
                    :min="0.001"
                    :active-change="false"
                    :formatter="value => `${this.$mul(100, value)} %`"
                    :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                  ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[2]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'sign_price_drop_judge_v2'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="发令枪幅度">
                <Tooltip content="当价格基于成本价朝着有利方向波动超过发令枪幅度, 才允许开始进行后续逻辑" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                    v-model="m_paras[0]"
                    :max="1"
                    :min="0"
                    :active-change="false"
                    :formatter="value => `${this.$mul(100, value)} %`"
                    :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                  ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="拉升触发/回落触发">
                <Tooltip content="拉升触发(Up)用于超跌反弹场景;回落触发(Down)用于冲高回落场景" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[1]" style="minwidth:200px">
                    <Option v-for="item in [{value:'up',label:'Up'}, {value:'down',label:'Down'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="拉升/回落临界幅度">
                <Tooltip content="拉升触发场景(Up):价格下跌刷新记录新低后回升, 回升现价/记录最低价-1>=临界幅度，即触发信号;回落触发场景(Down):价格上涨刷新记录新高后回落, 取绝对值(回落现价/记录最高价-1)>=临界幅度，即触发信号" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                    v-model="m_paras[2]"
                    :max="1"
                    :min="0.001"
                    :active-change="false"
                    :formatter="value => `${this.$mul(100, value)} %`"
                    :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                  ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[3]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'sign_price_drop_judge_v3'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="触发价格">
                <Tooltip content="当标的价格有效越过该值, 才允许开始进行后续逻辑" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                    v-model="m_paras[0]"
                    :min="0"
                    :active-change="false"
                  ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="拉升触发/回落触发">
                <Tooltip content="拉升触发(Up)用于超跌反弹场景;回落触发(Down)用于冲高回落场景" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[1]" style="minwidth:200px">
                    <Option v-for="item in [{value:'up',label:'Up'}, {value:'down',label:'Down'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="拉升/回落临界幅度">
                <Tooltip content="拉升触发场景(Up):价格下跌刷新记录新低后回升, 回升现价/记录最低价-1>=临界幅度，即触发信号;回落触发场景(Down):价格上涨刷新记录新高后回落, 取绝对值(回落现价/记录最高价-1)>=临界幅度，即触发信号" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                    v-model="m_paras[2]"
                    :max="1"
                    :min="0.001"
                    :active-change="false"
                    :formatter="value => `${this.$mul(100, value)} %`"
                    :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                  ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[3]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'trigger_immediately'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <Select v-model="m_paras[0]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'sign_stop_loss'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="止损百分比">
                <Tooltip content="输入3表示基于成本价3%不利幅度即止损" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber 
                      v-model="m_paras[0]"
                      :max="0.5"
                      :min="0.001"
                      :active-change="false"
                      :formatter="value => `${this.$mul(100, value)} %`"
                      :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                    ></InputNumber >
                </Tooltip>
              </FormItem>
              <FormItem label="推止损百分比">
                <Tooltip content="在做多时，-3表示不高于成本价-3%的推止损幅度;3表示不高于成本价3%的推止损幅度。做空以此类推" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                      v-model="m_paras[1]"
                      :max="0.5"
                      :min="-1"
                      :active-change="false"
                      :formatter="value => `${this.$mul(100, value)} %`"
                      :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                    ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'sign_stop_gain'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="止盈百分比">
                <Tooltip content="0.03,表示基于成本价达到3%的有利幅度即止盈" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                      v-model="m_paras[0]"
                      :max="10"
                      :min="0.001"
                      :active-change="false"
                      :formatter="value => `${this.$mul(100, value)} %`"
                      :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                    ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'sign_guaranteed_profit'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="发令枪幅度">
                <Tooltip content="当价格基于成本价朝着有利方向波动超过发令枪幅度, 才允许开始进行后续逻辑" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                    v-model="m_paras[0]"
                    :max="0.15"
                    :min="0"
                    :active-change="false"
                    :formatter="value => `${this.$mul(100, value)} %`"
                    :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                  ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="兜底止盈百分比">
                <Tooltip content="0.03,表示基于成本价的浮盈回落到3%的有利幅度即平仓" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                      v-model="m_paras[1]"
                      :max="0.15"
                      :min="0"
                      :active-change="false"
                      :formatter="value => `${this.$mul(100, value)} %`"
                      :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                    ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'default' && this.name === 'stop_loss'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="止损百分比">
                <Tooltip content="格式形如:0.03,表示基于成本价3%不利幅度即止损" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                      v-model="m_paras[0]"
                      :min="0.001"
                      :active-change="false"
                      :formatter="value => `${this.$mul(100, value)} %`"
                      :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                    ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="推止损百分比">
                <Tooltip content="在做多时，-0.03表示不高于成本价-3%的推止损幅度;0.03表示不高于成本价3%的推止损幅度。做空以此类推" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                      v-model="m_paras[1]"
                      :max="0.5"
                      :min="-1"
                      :active-change="false"
                      :formatter="value => `${this.$mul(100, value)} %`"
                      :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                    ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                    :disabled="true"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'default' && this.name === 'stop_gain'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="止盈百分比">
                <Tooltip content="0.03,表示基于成本价达到3%的有利幅度即止盈" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                      v-model="m_paras[0]"
                      :max="10"
                      :min="0.001"
                      :active-change="false"
                      :formatter="value => `${this.$mul(100, value)} %`"
                      :parser="value => this.$div(value.toString().replace('%', '').replace(' ', ''), 100)"
                    ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效百分比">
                  <Slider
                    v-model="m_execute_percent"
                    :step="1"
                    :max="100"
                    :min="1"
                    show-input
                    :disabled="true"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'function_type'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="订单执行方式">
                <Select v-model="m_paras[0]" @on-change="this.function_type_changed">
                  <Option v-for="item in this.function_type_index_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select> 
              </FormItem>
              <FormItem label="撤单阈值">
                <Tooltip content="撤单阈值：当前价格超过第一次挂单价格足够的比例，撤单重新下" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                        v-model="m_paras[1]"
                        :min="0.0003"
                        :max="0.008"
                        :active-change="false"
                        :formatter="value => `${this.$mul(10000, value)} ‱`"
                        :parser="value => this.$div(value.toString().replace('‱', '').replace(' ', ''), 10000)"
                      ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="市价极限">
                <Tooltip content="市价极限：市价部分亦为挂单成交，其价格为当前价*市价极限" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width" :placement="m_tooltip_placement">
                  <InputNumber
                        v-model="m_paras[2]"
                        :min="0.0003"
                        :max="0.01"
                        :disabled="m_paras[0] == 4||m_paras[0] == 5"
                        :active-change="false"
                        :formatter="value => `${this.$mul(10000, value)} ‱`"
                        :parser="value => this.$div(value.toString().replace('‱', '').replace(' ', ''), 10000)"
                      ></InputNumber>
                </Tooltip>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'strategy_msg'">
            <Form label-position="left" :label-width="140" :label-colon="true" ref="strategy_msg_validate" :model="m_paras" :rules="strategy_msg_form_rules">
              <FormItem label="执行标的" prop="current_symbol">
                <Select v-model="m_paras['current_symbol']" filterable :disabled="m_paras['create_or_alter_table_disabled']" clearable>
                  <Option v-for="item in this.symbol_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="策略名" prop="name">
                  <Input
                    v-model="m_paras.name"
                    clearable
                  ></Input>
              </FormItem>
              <FormItem label="策略描述信息" prop="description">
                  <Input
                    v-model="m_paras.description"
                    clearable
                    type="textarea"
                  ></Input>
              </FormItem>
              <FormItem label="绑定账户数量" prop="acc_count">
                  <InputNumber
                    v-model="m_paras['acc_count']"
                    readonly
                  ></InputNumber>
              </FormItem>
              <FormItem label="运行次数">
                  <InputNumber
                    v-model="m_paras['run_count']"
                    readonly
                  ></InputNumber>
              </FormItem>
              <FormItem label="上次更新时间">
                  <Input
                    v-model="m_paras['last_update_datetime']"
                    readonly
                  ></Input>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'select_strategy_msg'">
            <Form ref="select_strategy_ref" label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="策略ID">
                <Select v-model="select_strategy_id" filterable>
                  <Option v-for="item in get_select_strategy_list()" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="策略名" v-if="select_strategy_id != -1">
                <Input
                  v-model="select_strategy['strategy_name']"
                  readonly
                  placeholder="请输入策略名.."
                ></Input>
              </FormItem>
              <FormItem label="策略描述信息"  v-if="select_strategy_id != -1">
                  <Input
                    v-model="select_strategy['description']"
                    readonly
                    placeholder="请输入策略描述信息.."
                    type="textarea"
                  ></Input>
              </FormItem>
              <FormItem label="策略当前运行状态" v-if="select_strategy_id != -1">
                  <Input
                    v-model="select_strategy_status_code_index[select_strategy['current_status_code'].toString()]"
                    readonly
                  ></Input>
              </FormItem>
              <FormItem label="运行次数" v-if="select_strategy_id != -1">
                  <InputNumber
                    v-model="select_strategy['run_count']"
                    readonly
                  ></InputNumber>
              </FormItem>
              <FormItem label="上次更新时间" v-if="select_strategy_id != -1">
                  <Input
                    v-model="select_strategy['last_update_datetime']"
                    readonly
                  ></Input>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'tornado_setting'">
            <Form ref="select_strategy_ref" label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="模板对应策略编号">
                <Select v-model="m_paras[0]" filterable>
                  <Option v-for="item in get_select_tornado_setting_list()" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Form>
          </div>
          <div v-else>
          </div>
          </Col>
        </Row>
      </Modal>
    </Row>
  </div>
</template>
<script>
//import func from 'vue-editor-bridge'
import store from '../../store'

export default {
  name: "flexible_render_modal_view",
  data() {
    return {
      timer:null,
      //["1m", "3m", "5m", "15m", "30m", "1h", "2h", "4h", "6h", "8h", "12h"]
      ma_interval:{
        "m":[
          {value: 1,label: '1'},
          {value: 3,label: '3'},
          {value: 5,label: '5'},
          {value: 15,label: '15'},
          {value: 30,label: '30'},
        ],
        "h":[
          {value: 1,label: '1'},
          {value: 2,label: '2'},
          {value: 4,label: '4'},
          {value: 6,label: '6'},
          {value: 8,label: '8'},
          {value: 12,label: '12'},
        ]
      },
      function_type_index_list: [],
      select_strategy_status_code_index: {
        "0":'待启动',
        "1":'正在运行',
        "2":'历史策略',
        "-1":'',
      },
      m_paras:null,
      m_name:"",
      m_type:"",
      m_execute_percent:100,
      m_open_modal_switch:false,

      //信号、止盈止损等输入框体的提示
      m_tooltip_delay:3000,
      m_tooltip_max_width:200,
      m_tooltip_placement:"right",
      
      //当用户在选择录入的ID时, 所有状态使用该object控制
      select_strategy_id:null,
      select_strategy:{
        "current_status_code":'-1',
        "current_symbol":null,
        "run_count":null,
        "strategy_name":null,
        "last_update_datetime":null,
        "description":null,
      },
      loading_status:true,
      strategy_msg_form_rules:{
        name: [
            { required: true, message: '策略名不能为空', trigger: 'blur' }
        ],
        description: [
            { required: true, message: '描述信息不能为空', trigger: 'blur'}
        ],
        acc_count: [
          { required: true, message: '至少绑定一个账户', trigger: 'blur', type:"number", min:1}
        ],
        current_symbol: [
          { required: true, message: '标的不能为空', trigger: 'blur',type:"string" }
        ]
      },
      // 灵活策略--存储上次获得symbol_list的时间
      last_timestamp_get_symbol_list:new Date().getTime(),
      // 存储当前获得的symbol_list
      symbol_list:[],
    }
  },
  props: {
    paras: {
      type: [Array, Object],
    },
    open_modal_switch:{
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    modal_type: {
      type: String,
      default: ""
    },
    open_or_close: {
      type: String,
      validator: function(value) {
        return ["open", "close"].indexOf(value) != -1
      }
    },
    execute_percent: {
      type: [Number, String],
      default: 1.0,
      validator: function(value) {
        var _value = Number(value)
        if (_value > 0 && _value <=1 ) {
          return true
        } else {
          return false
        }
      }
    }
  },
  methods:{
    get_symbol_list: async function(){
      // 获得展示在灵活策略Flexible上标的列表
      if ((new Date().getTime() - this.last_timestamp_get_symbol_list > 600 * 1000) || 
          (this.symbol_list.length == 0)) {

          let axios_symbol_list = []
          let data = await this.$axios.get(
              this.$store.state.urlPort + "/flexible_strategy",
              {
                params: {
                  mode: "get_flexible_symbol_list",
                }
              }
            )
          if (data != "error") {
              axios_symbol_list = data["data"]
          } else {
              axios_symbol_list = {"data":["BTCUSDT"]}
          }
          this.last_timestamp_get_symbol_list = new Date().getTime()
          let tmp = []
          for (var i = 0; i < axios_symbol_list.length; i++) {
            tmp.push({
              "value":axios_symbol_list[i],
              "label":axios_symbol_list[i],
            })
          }
          this.symbol_list = tmp
      }
    },
    get_select_strategy_list: function() {
      let strategy_list = []
      // 根据后台的数据，展示所有可以被选择的策略ID
      for (var key in this.m_paras) {
        key = key.toString()
        if (key != "-1") {
          strategy_list.push({
            "value":key,
            "label":key+"号",
          })
        } else {
          strategy_list.push({
            "value":key,
            "label":"创建新策略",
          })
        }
      }
      return strategy_list
    },
    get_select_tornado_setting_list: function() {
      // 返回当前可供选择成为策略模板的所有策略编号
      let tornado_setting_list = [{
            "value":"-1",
            "label":"默认选项",
      }]
      for (var key in this.m_paras[1]) {
        key = key.toString()
        if (key != "-1") {
          tornado_setting_list.push({
            "value":key,
            "label":key,
          })
        }
      }
      return tornado_setting_list
    },
    get_modal_title: function() {
      if (this.m_type === 'strategy_msg' && this.uuid.toString() === "-1") {
        return "提交新策略参数"
      } else if (this.m_type === 'strategy_msg' && this.uuid.toString() != "-1") {
        return "修改参数"
      } else if (this.m_type === 'select_strategy_msg') {
        return "选择策略，修改参数"
      } else {
        return "修改参数"
      }
    },
    set_ok_for_type_strategy_msg: function(){
      this.$refs["strategy_msg_validate"].validate((valid) => {
          if (valid) {
            this.loading_status = true
            this.$emit("modal_click", {
              "paras":this.m_paras,
              "name":this.m_name,
              "uuid":this.uuid,
              "m_type":this.m_type,
              "mode":"ok",
            })
          } else {
            setTimeout(() => {
              this.loading_status = false;
              this.$nextTick(()=>{
                this.loading_status = true;
              })
            }, 200);
          }
          return null
      }, (error) => {
        console.log("检验函数遇到错误")
        console.log(error)
      })
    },
    set_ok: function() {
      if (this.m_type === "select_strategy_msg") {
        this.select_strategy["id"] = this.select_strategy_id
        this.select_strategy['strategy_name'] = this.select_strategy['strategy_name'].replace("\n", " ")
        this.select_strategy['description'] = this.select_strategy['description'].replace("\n", " ")
        this.$emit("modal_click", {
          "paras":this.m_paras,
          "uuid":this.uuid,
          "execute_percent":this.$div(this.m_execute_percent, 100),
          "m_type":this.m_type,
          "select_strategy":this.select_strategy,
          "mode":"ok",
        })
      } else if (this.m_type === "strategy_msg") {
        this.set_ok_for_type_strategy_msg()
      } else if (this.m_type === "tornado_setting") {
        this.$emit("modal_click", {
          "paras":[this.m_paras[0]],
          "m_type":this.m_type,
          "mode":"ok",
        })
      } else {
        this.$emit("modal_click", {
          "paras":this.m_paras,
          "name":this.m_name,
          "uuid":this.uuid,
          "execute_percent":this.$div(this.m_execute_percent, 100),
          "m_type":this.m_type,
          "mode":"ok",
        })
      }
    },
    set_cancel: function() {
      this.$emit("modal_click", {
        "mode":"cancel",
      })
    },
    set_changed: function(value) {
      if (value == false) {
        setTimeout(() => {
          this.m_type = ""
        }, 250);
      }
    },
    m_or_h_change: function(){
      this.paras[2] = 1
    },
    function_type_changed: function(value) {
      // 当选择了限价、市价两种订单执行方式，需要重设 撤单阈值界 跟 市价阈值
      if (value == 0) {
        this.m_paras[1] = 0.0005
        this.m_paras[2] = 0.01
      } else if (value == 1) {
        this.m_paras[1] = 0.0005
        this.m_paras[2] = 0.0003
      } else if (value == 4) {
        this.m_paras[1] = 0.001
        this.m_paras[2] = 0.01
      }
    },
    // 设定循环执行的内容
    setTimer: function(interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.get_symbol_list()
        }, interval);
      }
    },
  },
  mounted: function() {
    var function_type_index = store.state.function_type_index
    this.function_type_index_list = []
    for (var key in function_type_index ) {
      this.function_type_index_list.push({
        value:Number(key), label:function_type_index[key]
      })
    }
    this.get_symbol_list()
  },
  created: function() {
    clearInterval(this.timer);
    this.timer = null;
    // 5分钟一刷新
    this.setTimer(5 * 60 * 1000);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
  watch: {
    open_modal_switch(old_value) {
      // 避免直接由内部修改props的情况
      this.m_open_modal_switch = this.open_modal_switch
      if (this.m_open_modal_switch == true) {
        // 在打开modal的时候初始化参数
        this.m_paras = JSON.parse(JSON.stringify(this.paras))
        this.m_name = this.name
        this.m_type = this.modal_type
        this.m_execute_percent = Number((this.execute_percent * 100).toFixed(0))
        if (this.m_type === "select_strategy_msg" || this.m_type === "strategy_msg") {
          // 在选择导入的ID时，需要初始化前端的输入
          this.select_strategy_id = this.uuid
        }
      } else {

      }
    },
    select_strategy_id(old_value) {
      if (this.select_strategy_id == null) { return null }
      if (this.select_strategy_id.toString() != "-1" && this.m_type === "select_strategy_msg") {
        let select_con = null
        // 当选择id改变，需要同时改变其他显示信息
        for (var i = 0; i < this.m_paras[this.select_strategy_id].length; i++) {
          if (this.m_paras[this.select_strategy_id][i]["type"] === "strategy_msg") {
            select_con = this.m_paras[this.select_strategy_id][i]
            break
          }
        }
        if (select_con === null) {
          console.log("wrong select_strategy_id")
          return null
        }
        this.select_strategy["current_status_code"] = select_con["paras"]["current_status_code"]
        this.select_strategy["current_symbol"] = select_con["paras"]["current_symbol"]
        this.select_strategy["run_count"] = select_con["paras"]["run_count"]
        this.select_strategy["strategy_name"] = select_con["paras"]["name"]
        this.select_strategy["last_update_datetime"] = select_con["paras"]["last_update_datetime"]
        this.select_strategy["description"] = select_con["paras"]["description"]
      } else {
        this.select_strategy["current_status_code"] = '-1'
        this.select_strategy["current_symbol"] = ""
        this.select_strategy["run_count"] = 0
        this.select_strategy["strategy_name"] = null
        this.select_strategy["last_update_datetime"] = null
        this.select_strategy["description"] = null
      }
    }
  }
}
</script>
<style>
.demo-drawer-hearde {
  text-align:center;
}
</style>